import index from '@/pages/index';
import news from '@/pages/news';
import history from '@/pages/history';
import charter from '@/pages/charter';
import director from '@/pages/director';
import supervisory from '@/pages/supervisory';
import activity from '@/pages/activity';
import silhouette from '@/pages/silhouette';
import calendar from '@/pages/calendar';
import journal from '@/pages/journal';
import journaldetail from '@/pages/journaldetail';
import videoplatform from '@/pages/videoplatform';
import health from '@/pages/health';
import decision from '@/pages/decision';
import feedback from '@/pages/feedback';
import submission from '@/pages/submission';
import admission from '@/pages/admission';
import registered from '@/pages/registered';
import memberStatus from '@/pages/memberStatus';
import memberInfo from '@/pages/memberInfo';
import memberAct from '@/pages/memberAct';
import changePsw from '@/pages/changePsw';
import contactus from '@/pages/contactus';
import enroll from '@/pages/enroll';
import header from '@/pages/header';
import footer from '@/pages/footer';
import forgotpassword from '@/pages/forgotpassword';
import verification from '@/pages/verification';
import relatedinformation from '@/pages/download';
import activityprocesslist from '@/pages/agenda';
//components
import Banner from '@/components/banner';
import Title from '@/components/Title';
import graybtn from '@/components/btn/gray';
import PDFicon from '@/components/pdficon';
import gotop from '@/components/gotop';
import loading from '@/components/loading';
import notfound from '@/components/notfound';
// import "@/components";

import VueSweetalert2 from 'vue-sweetalert2';
import fullCalendar from 'vue-fullcalendar';
import infiniteScroll from 'vue-infinite-scroll';
import Print from 'vue-print-nb';
import store from './store';
// import LazyLoadDirective from './../static/js/LazyLoadDirective';
import moment from 'moment';
import 'moment/locale/zh-tw';
Vue.prototype.$moment = moment;
Vue.component('full-calendar', fullCalendar);
Vue.use(VueSweetalert2);
Vue.use(infiniteScroll);
Vue.use(Print);
Vue.use(store);
// Vue.use(require("vue-moment"));
// Vue.directive('lazyload', LazyLoadDirective);
const components = [
  header,
  footer,
  index,
  news,
  history,
  charter,
  director,
  supervisory,
  activity,
  silhouette,
  calendar,
  journal,
  journaldetail,
  videoplatform,
  relatedinformation,
  health,
  decision,
  feedback,
  submission,
  admission,
  registered,
  memberStatus,
  memberInfo,
  memberAct,
  changePsw,
  contactus,
  enroll,
  Banner,
  Title,
  graybtn,
  PDFicon,
  forgotpassword,
  verification,
  gotop,
  loading,
  notfound,
  activityprocesslist
];
const install = (Vue, opts = {}) => {
  components.map(component => {
    Vue.component(component.name, component);
  });
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default { ...components, install };



// WEBPACK FOOTER //
// ./src/main.prod.js